import React from 'react';
import { FormControlLabel, Grid } from '@mui/material';
import TeamFilters from '../components/TeamFilters';
import RoleFilters from '../components/RoleFilters';
import { ComboBoxOption } from '../components/form/controls/ComboBox';
import Checkbox from '@mui/material/Checkbox';
import { storeIncludeProxy } from '../components/form/react-hook-form-components/FilterStorage';

export interface IFilterOptions {
  team: ComboBoxOption | null;
  roles: ComboBoxOption[];
  proxy: boolean | undefined;
}

interface IFilterOptionsProps {
  state: IFilterOptions;
  setState: React.Dispatch<React.SetStateAction<IFilterOptions>>;
  page: string;
}

function FilterOptions(props: IFilterOptionsProps) {
  const { state, setState, page } = props;
  const storageKeyRoles = page + 'Roles';
  const storageKeyTeam = page + 'Team';
  const storageKeyProxy = page + 'Proxy';

  const handleChange = () => {
    let proxy = !state.proxy;
    setState({
      ...state,
      proxy,
    });
    storeIncludeProxy(storageKeyProxy, proxy);
  };

  return (
    <Grid container spacing={1} justifyContent="center">
      <Grid item xs={3}>
        <RoleFilters state={state} setState={setState} page={storageKeyRoles} />
      </Grid>
      <Grid item xs={3}>
        <TeamFilters state={state} setState={setState} page={storageKeyTeam} />
      </Grid>
      <Grid item>
        <FormControlLabel
          control={
            <Checkbox
              onChange={handleChange}
              checked={state.proxy}
              size="small"
              sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }}
            />
          }
          label="Proxies"
          value="top"
          labelPlacement="top"
        />
      </Grid>
    </Grid>
  );
}

export default FilterOptions;
